<div class="card-header mb-4">
  <div class="title-section">
    <h2 class="header-title">Customizables</h2>
    <div class="client-info">
      <p class="mb-1">
        Clave: <strong>{{ this.model.sClave || this.model.sEmpresa }}</strong>
      </p>
      <p class="mb-0">
        {{ this.model.sTipo || 'Empresa' }}: <strong>{{ this.model.sNombre }}</strong>
      </p>
    </div>
  </div>
  <div class="button-section">
    <button mat-flat-button (click)="newModal = true" class="btn-new" *ngIf="model" appPermissionControl="P102B0001"><mat-icon>add</mat-icon> Nuevo</button>
    <button mat-flat-button (click)="close()" class="btn-delete" appPermissionControl="P102B0002"><mat-icon>close</mat-icon> Cerrar</button>
  </div>
</div>

<div class="mt-3">
  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[5, 10, 20, 40]"
    [scrollable]="true"
    [scrollHeight]="'calc(100vh - 250px)'"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P102T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P102C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="editValueCustom(rowData)"
                  [disabled]="!rowData.sValor"
                  appPermissionControl="P102B0003"
                ></button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deleteCustom(rowData)" appPermissionControl="P102B0004"></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'sCampo'">
              <ng-container *ngIf="!rowData.sValor">
                <a href="javascript:void(0)" (click)="editValueCustom(rowData)" class="text-primary">
                  {{ rowData[col.field] }}
                </a>
              </ng-container>
              <ng-container *ngIf="rowData.sValor">
                {{ rowData[col.field] }}
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="newModal" [style]="{ width: '50vw' }" [contentStyle]="{ padding: '1' }" [modal]="true" [draggable]="false" [resizable]="false" header="Nuevo Customizable" (onShow)="onNewModalShow()">
  <div class="form-field mt-3">
    <label>Customizable</label>
    <p-dropdown 
      [(ngModel)]="valueNewCustomizable" 
      [options]="listCustomizables || []" 
      optionLabel="sCampo" 
      optionValue="sCampo"
      [filter]="true"
      [showClear]="true"
      [virtualScroll]="listCustomizables && listCustomizables.length > 100"
      [virtualScrollItemSize]="38"
      placeholder="Seleccione un customizable"
      class="w-100"
      appendTo="body"
      [autoZIndex]="true"
      [baseZIndex]="200000"
      [filterBy]="'sCampo,sTipo,sTabla'"
      appPermissionControl="P102K0001">
    </p-dropdown>
  </div>

  <ng-template pTemplate="footer">
    <div class="button-section">
      <button mat-flat-button class="btn-success" (click)="addCustomizable()" [disabled]="!valueNewCustomizable" appPermissionControl="P102B0005">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
      <button mat-flat-button (click)="newModal = false" class="btn-delete" appPermissionControl="P102B0006">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="newModalValue"
  [style]="{ width: '50vw' }"
  [contentStyle]="{ padding: '1' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  header="Editar Customizable"
>
  <div class="form-field mt-3">
    <label
      >{{ customItem?.sCampo }} <small>({{ customItem?.sTipo }})</small></label
    >
    <ng-container [ngSwitch]="getInputType(customItem?.sTipo)">
      <!-- Campo tipo Opción -->
      <p-dropdown 
        *ngSwitchCase="'select'" 
        [(ngModel)]="valueCustom" 
        [options]="listOpciones || []" 
        [filter]="true"
        [showClear]="true"
        [virtualScroll]="listOpciones?.length > 100"
        [virtualScrollItemSize]="38"
        placeholder="Seleccione una opción"
        appendTo="body"
        [autoZIndex]="true"
        [baseZIndex]="200000"
        class="w-100"
        [loading]="loading"
        appPermissionControl="P102K0004">
      </p-dropdown>

      <!-- Campo Alfanumérico -->
      <input *ngSwitchCase="'text'" type="text" class="form-control" [(ngModel)]="valueCustom" placeholder="Ingrese valor alfanumérico" appPermissionControl="P102K0007" />

      <!-- Campo Numérico -->
      <input *ngSwitchCase="'number'" type="number" class="form-control" [(ngModel)]="valueCustom" placeholder="Ingrese valor numérico" [max]="maxValue" appPermissionControl="P102K0008" />

      <!-- Campo Fecha -->
      <input *ngSwitchCase="'date'" type="date" class="form-control" [(ngModel)]="valueCustom" appPermissionControl="P102K0009" />

      <!-- Por defecto, input text -->
      <input *ngSwitchDefault type="text" class="form-control" [(ngModel)]="valueCustom" placeholder="Ingrese valor" appPermissionControl="P102K0010" />
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="button-section">
      <button mat-flat-button class="btn-success" (click)="sendValueCustom()" [disabled]="!valueCustom" appPermissionControl="P102B0007">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </div>
  </ng-template>
</p-dialog>
